import React from "react";
import { Link } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";

const Breadcrumb = ({ paths }) => {
  return (
    <nav
      className="flex items-center space-x-3 text-gray-600 font-inter"
      aria-label="Breadcrumb"
    >
      {paths.map((path, index) => (
        <React.Fragment key={index}>
          {index !== 0 && (
            <span className="text-gray-600 font-inter text-3xl xl:text-lg 3xl:text-3xl">
              {" "}
              <IoIosArrowForward />{" "}
            </span>
          )}
          {index < paths.length - 1 ? (
            path.href ? (
              <Link to={path.href} className="hover:text-blue">
                {path.label}
              </Link>
            ) : (
              <span className="text-gray-400 cursor-default">{path.label}</span>
            )
          ) : (
            <span className="text-blue font-interBold  text-3xl xl:text-lg 3xl:text-3xl">
              {path.label}
            </span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;
